<template>
  <div class="employee">
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="table-responsive">
              <table class="table table-mobile">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                      {{ $t("customer.label_customer_company_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("customer.label_customer_abbreviations") }}
                    </th>
                    <th scope="col">
                      {{ $t("customer.label_customer_investment") }}
                    </th>
                    <th scope="col">
                      {{ $t("customer.label_customer_rank") }}
                    </th>
                    <th scope="col">
                      {{ $t("customer.label_customer_homepage") }}
                    </th>
                    <th scope="col">
                      {{ $t("customer.label_customer_number_employee") }}
                    </th>
                    <th scope="col" style="width: 150px; text-align: center">
                      {{ $t("employee.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in listCustomers" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>
                      <router-link
                        :to="{
                          name: 'customers.detail',
                          params: { id: item.id }
                        }"
                        tag="a"
                      >
                        {{ item.company_name }}
                      </router-link>
                    </td>
                    <td>{{ item.abbreviations }}</td>
                    <td>{{ item.investment }} 万円</td>
                    <td>
                      {{ $t("customer.label_customer_rank") }} {{ item.rank }}
                    </td>
                    <td>
                      <a v-bind:href="item.website" target="_blank">{{
                        item.website
                      }}</a>
                    </td>
                    <td>{{ item.number_employee }}</td>
                    <td
                      class="py-2 d-flex justify-content-center"
                      style="width: 180px"
                    >
                      <span class="mr-1"></span>
                      <router-link
                        :to="{
                          name: 'customers.update',
                          params: { id: item.id }
                        }"
                        tag="a"
                      >
                        <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                        >
                          {{ $t("button.label_action_edit") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span>
                      <CButton
                        color="danger"
                        variant="outline"
                        square
                        size="sm"
                        @click="deleteCustomer(item)"
                      >
                        {{ $t("button.label_action_delete") }}
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CustomerIndex",
  metaInfo() {
    return {
      title: this.$t("page_title.page_customer_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      listCustomers: [],
      searchData: {
        company_name: "",
        customer_status: "",
        customer_type: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 0,
          totalRecord: 0,
          perPage: 0
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      customers: "customer/customers",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "customer/pagination"
    })
  },
  methods: {
    ...mapActions("customer", ["fetchCustomer", "delete"]),
    ...mapActions("commons", ["getCommonsData"]),

    async fetchCustomerData() {
      await this.fetchCustomer({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage
      });
      this.searchData.paginate = this.pagination;
      this.listCustomers = this.customers.data;
    },

    async getCommons() {
      await this.getCommonsData();
    },

    changePage(page) {
      this.fetchCustomerData(this.searchData.itemsPerPage, page);
    },

    async deleteCustomer(customer) {
      this.$confirm(
        `${this.$t("commons.label_delete")} ${customer.company_name}`,
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.delete(customer.id)
            .then(() => {
              this.fetchCustomerData();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    }
  },
  created() {
    this.fetchCustomerData();
    this.getCommons();
  }
};
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 0 -30px;
  .employee-table {
    margin: 27px 27px 0 30px;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
}
@media screen and (max-width: 767px) {
  .card-body {
    padding: 0 0.5rem;
  }
  .table-mobile {
    width: 900px;
    overflow-x: scroll;
  }
}
</style>
